import { render, staticRenderFns } from "./checkers.vue?vue&type=template&id=e85a6d6a&scoped=true&lang=html&"
import script from "./checkers.vue?vue&type=script&lang=js&"
export * from "./checkers.vue?vue&type=script&lang=js&"
import style0 from "./checkers.vue?vue&type=style&index=0&id=e85a6d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85a6d6a",
  null
  
)

component.options.__file = "checkers.vue"
export default component.exports